import React from 'react';
import Button from './Button';
import logo from '../assets/Contopet-Logo_no_payoff.png';
import { useNavigate } from 'react-router-dom';
import MyText from './MyText';
import { useAuth } from '../context/AuthContext';

export default function Header({ importo, path }) {
    const navigate = useNavigate();
    const { userInfo } = useAuth();
    return (
        <header style={styles.header}>
            <img style={styles.image} src={logo} alt="Logo" />
            {userInfo && <div>
                <MyText style={styles.myText}>{userInfo.firstname} {userInfo.lastname}</MyText>
            </div>}
            {path &&
            <div >
                <Button
                    containerStyle={styles.btnContainer}
                    text={path === "/RegistraAcquisto" ? "Nuova ricerca" : "Annulla"}
                    callback={() => navigate(-1)}
                    textStyle={{color: "white"}}
                />
            </div>}
        </header>
    );
}
const styles = {
    header: {
        // backgroundColor: '#282d68',
        // minHeight: '100vh',
        // maxHeight: '10vh',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'white',
        padding: '10px 20px',
        gap: '20px',
        alignSelf: 'flex-start',
    },
    image: {
        maxHeight: '8vh',
    },
    myText: {
        fontSize: '1.5rem',
        color: "#282d68"
    },
    btnContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        // width: "30%"
    }
}